/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOSubmitUtilityVerificationResponseDTO } from '../models/ApiResponseDTOSubmitUtilityVerificationResponseDTO';
import type { ApiResponseDTOUtilityVerificationStatusResponseDTO } from '../models/ApiResponseDTOUtilityVerificationStatusResponseDTO';
import type { SubmitUtilityBvnSelfieVerifyRequestDTO } from '../models/SubmitUtilityBvnSelfieVerifyRequestDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VerificationService {

    /**
     * Get Verification Status
     * Get verification status by jobId - works for BVN, selfie, or combined verifications
     * @param jobId 
     * @returns ApiResponseDTOUtilityVerificationStatusResponseDTO OK
     * @throws ApiError
     */
    public static getVerificationStatus(
jobId: string,
): CancelablePromise<ApiResponseDTOUtilityVerificationStatusResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/utility/bvn-selfie/status/{jobId}',
            path: {
                'jobId': jobId,
            },
            errors: {
                400: `Bad Request`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Submit Combined BVN & Selfie Verification
     * Submit combined BVN and selfie verification - reusable utility API for independent verification
     * @param requestBody 
     * @returns ApiResponseDTOSubmitUtilityVerificationResponseDTO OK
     * @throws ApiError
     */
    public static submitBvnSelfieVerification(
requestBody: SubmitUtilityBvnSelfieVerifyRequestDTO,
): CancelablePromise<ApiResponseDTOSubmitUtilityVerificationResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/bvn-selfie/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
